<template>
    <div class="field">
        <label class="label">Year range</label>
        <div class="field has-addons has-addons-right">
            <p class="control">
                <span class="select is-fullwidth">
                    <select v-model="minYear">
                        <option v-for="year in years">{{ year }}</option>
                    </select>
                </span>
            </p>
            <p class="control helper-to">
                <span class="button is-static">To:</span>
            </p>
            <p class="control">
                <span class="select is-fullwidth">
                   <select v-model="maxYear">
                        <option v-for="year in years">{{ year }}</option>
                   </select>
                </span>
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        components: {

        },
        data() {
            return {
                years: [],
            }
        },
        computed: {
            minYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMinValue', value)
                }
            },
            maxYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMaxValue', value)
                }
            }
        },
        methods: {
            generateYearsArrays() {
                let minOffset = 0, maxOffset = 80; // Change to whatever you want
                let thisYear = (new Date()).getFullYear();
                let years = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    years.push(thisYear - i);
                }

                this.years = years
            }
        },
        created() {
            this.generateYearsArrays()
        }
    }
</script>

<style scoped>
    .control {
        width: 100%;
    }
    .helper-to {
        width: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/YearRangeSlider.vue